import type { Messages } from '../en'

export const newRun: Messages['newRun'] = {
  backToFlows: 'Fluxos',
  flowNotAvailable: 'Este fluxo não está disponível para a sua empresa.',
  missingFlowId: 'ID do fluxo ausente.',
  briefLabel: 'O que você precisa?',
  briefPlaceholder: 'Descreva a tarefa com suas palavras…',
  launch: 'Iniciar',
  mayPauseHint: 'Este fluxo pode fazer uma pausa para tirar uma dúvida com você.',

  // Uma execução que falhou antes de voltar qualquer resposta
  notStarted: 'A execução não começou.',
  unreachable: 'Não foi possível falar com o portal. Confira sua conexão e tente de novo.',
  interrupted:
    'A conexão caiu enquanto a execução trabalhava. Ela pode continuar em andamento: abra-a para ver em que pé está.',
  interruptedEarly:
    'A conexão caiu quando a execução começava. Ela pode estar em andamento: veja o Histórico antes de iniciar de novo, para ela não rodar duas vezes.',
  backToRequest: 'Voltar ao pedido',
  openRun: 'Abrir esta execução',
  openHistory: 'Abrir o Histórico',

  // AttachmentPicker
  attachTitle: 'Anexos',
  attachMeterEmpty: (cap) => `0 anexos · limite de ${cap}`,
  attachMeterUsed: (n, used, cap) => `${n} ${n === 1 ? 'anexo' : 'anexos'} · ${used} / ${cap}`,
  attachDropzoneAria: 'Adicionar anexos — solte arquivos ou pressione Enter para procurar',
  attachDropzoneHint: (cap) => `Solte arquivos aqui ou toque para procurar — até ${cap} no total`,
  attachRemove: (name) => `Remover ${name}`,
  attachFolderUnsupported: 'Não é possível soltar pastas. Solte arquivos individuais.',
  attachPerFileExceeded: (name, cap) => `"${name}" excede o limite de ${cap} por arquivo.`,
  attachTotalExceeded: (total, cap) => `O total de ${total} excederia o limite de ${cap}.`,
  attachTooMany: (count, max) => `${count} arquivos — no máximo ${max} podem ser anexados.`,
  attachDropzoneHintPlain: 'Solte arquivos aqui ou toque para procurar',
  attachUploading: (name) => `Enviando ${name}`,
  attachRetry: (name) => `Tentar enviar ${name} de novo`,
  attachFailed: 'Um envio falhou. Tente de novo ou remova o arquivo.',
  attachWaiting: 'Aguardando o envio dos arquivos terminar…'
}
